export default "__VITE_ASSET__BqEEztlP__"